import React, { useState, useContext, useMemo, useEffect } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import BasicForm from './Components/Form/BasicForm'
import Parameters from './Components/Form/Parameters'
import Schedule from './Components/Form/Schedule'
import Charts from './Components/Form/Charts'
import { OutorgaContext } from '../../../contexts/Outorga'
import helper from '../../../utils/helper'
import permission from '../../../utils/permissions'
import auth from '../../../utils/auth'

const Form = (props) => {
    const context = useContext(OutorgaContext)
    const grantId = props.match.params.id

    const [tab, setTab] = useState(0)

    useEffect(() => {
        return () => {
            context.resetState();
        };
    }, []);

    const tabsConfig = [
        {
            key: 'outorga',
            title: 'Outorga',
            component: BasicForm,
            endpoints: ['/ambiental/outorga']
        },
        {
            key: 'parametrizacao',
            title: 'Parametrização',
            component: Parameters,
            endpoints: ['/condicao/parametro/bulk/'],
            disabled: !grantId
        },
        {
            key: 'cronograma',
            title: 'Cronograma',
            component: Schedule,
            endpoints: ['/cronograma/'],
            disabled: !grantId
        },
        {
            key: 'graficos',
            title: 'Gráficos',
            component: Charts,
            endpoints: [
                '/parametro/grafico/bulk/',
                '/parametro/grafico/',
                '/parametro/tipo/grafico/'
            ],
            disabled: !grantId
        },
    ]

    const tabsFiltered = useMemo(() => {
        if (auth.isMasterOrAdmin()) return tabsConfig;

        return tabsConfig.filter(tab =>
            permission.canAny(tab.endpoints, null)
        )
    }, [grantId])

    const handleTab = (nextIndex) => {
        const {
            hasUnsavedParams,
            hasUnsavedBasicInfo,
            hasUnsavedSchedule,
            hasUnsavedCharts,
            setUnsavedDefaultParams,
            setUnsavedCustomParams,
            setNotAddedCustomParams,
            setUnsavedSchedule,
            setUnsavedCharts
        } = context

        const currentTabKey = tabsFiltered[tab]?.key
        const nextTabKey = tabsFiltered[nextIndex]?.key

        const isLeaving = (key) =>
            currentTabKey === key && nextTabKey !== key

        if (isLeaving('outorga') && hasUnsavedBasicInfo()) {
            helper.dispatchEvent("showAviso", {
                message: "Existem informações da outorga não salvas! Deseja continuar?",
                callback: () => setTab(nextIndex)
            })
            return false
        }

        if (isLeaving('parametrizacao') && hasUnsavedParams()) {
            helper.dispatchEvent("showAviso", {
                message: "Existem parâmetros não salvos! Deseja continuar?",
                callback: () => {
                    setTab(nextIndex)
                    setUnsavedDefaultParams()
                    setUnsavedCustomParams()
                    setNotAddedCustomParams()
                }
            })
            return false
        }

        if (isLeaving('cronograma') && hasUnsavedSchedule()) {
            helper.dispatchEvent("showAviso", {
                message: "Existem informações de cronograma não salvos! Deseja continuar?",
                callback: () => {
                    setTab(nextIndex)
                    setUnsavedSchedule()
                }
            })
            return false
        }

        if (isLeaving('graficos') && hasUnsavedCharts()) {
            helper.dispatchEvent("showAviso", {
                message: "Existem gráficos da outorga não salvos! Deseja continuar?",
                callback: () => {
                    setTab(nextIndex)
                    setUnsavedCharts()
                }
            })
            return false
        }

        setTab(nextIndex)
    }

    return (
        <Tabs
            className="tabs-style"
            selectedIndex={tab}
            onSelect={handleTab}
        >
            <TabList>
                {tabsFiltered.map((tabItem, index) => (
                    <Tab key={tabItem.key} disabled={tabItem.disabled}>
                        {tabItem.title}
                    </Tab>
                ))}
            </TabList>

            {tabsFiltered.map((tabItem) => {
                const Component = tabItem.component

                return (
                    <TabPanel key={tabItem.key}>
                        <Component
                            grantId={grantId}
                            history={props.history}
                            permissions={permission.getAllFromEndpoints(tabItem.endpoints)}
                            isMasterOrAdmin={auth.isMasterOrAdmin()}
                        />
                    </TabPanel>
                )
            })}
        </Tabs>
    )
}

export default Form